import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpeakerNotesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"speaker_notes"}/>
}
